import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button, Flex } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';

import { FormFooter } from '../../../../common/components';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { LostItemsFormActionType } from '../../model/enums/lost-items-form-action-type.enum';
import { useLostItemsHook } from '../../utils/hooks/use-lost-items.hook';
import { LostItemsActionType } from '../LostItemsActionType/LostItemsActionType';
import { LostItemsCsvFile } from '../LostItemsCsvFile/LostItemsCsvFIle';
import { LostItemsInventoryCountSelect } from '../LostItemsInventoryCountSelect/LostItemsInventoryCountSelect';
import { LostSummaryModal } from '../LostSummaryModal/LostSummaryModal';
import {
  lostItemsFormDefaultValues,
  LostItemsFromCsvFormType,
  useMarkLostItemsFromCsvFormValidation,
} from './LostItems.form';

export const LostItemsForm = () => {
  const translations = useTranslations();
  const validationSchema = useMarkLostItemsFromCsvFormValidation();
  const methods = useForm<LostItemsFromCsvFormType>({
    defaultValues: lostItemsFormDefaultValues,
    resolver: yupResolver(validationSchema),
  });
  const { items, isSubmitFormLoading, handleFormSubmit, handleCloseSummaryModal, isSummaryModalOpen } =
    useLostItemsHook(methods);
  const watchLostActionType = methods.watch('action');

  const handleClearForm = () => {
    methods.reset();
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleFormSubmit}>
          <LostItemsCsvFile />
          <LostItemsActionType />
          {watchLostActionType === LostItemsFormActionType.MARK_AS_LOST ? (
            <Flex width={['100%', '100%', '50%']}>
              <LostItemsInventoryCountSelect />
            </Flex>
          ) : null}
          <FormFooter hasCustomContent>
            <Button variant="primary" mb={2} mr={4} isLoading={isSubmitFormLoading} type="submit">
              {translations('lost_items_execute_button')}
            </Button>
            <Button variant="secondary" onClick={handleClearForm}>
              {translations('lost_items_clear_button')}
            </Button>
          </FormFooter>
        </form>
      </FormProvider>
      <LostSummaryModal
        isOpen={isSummaryModalOpen}
        onClose={handleCloseSummaryModal}
        action={watchLostActionType}
        items={items}
      />
    </>
  );
};
